import React from 'react';

import PropTypes from 'prop-types';

import { size } from 'lodash';

import { showIf } from './index';

export function Observacoes({ observacoes, data, definicao, debugId }) {
	if (typeof observacoes === 'string') {
		if (size(observacoes) > 0) {
			observacoes = [{ text: observacoes }];
		}
	} else {
		observacoes = observacoes.filter(obs => showIf(data, definicao, obs.showIf, `observacao ${debugId}`));
	}

	return size(observacoes) === 0 ? null : (
		<div className="observacoes">
			{observacoes.map((obs, index) => (
				<div key={index} className={obs.type || 'info'}>
					<span>{`${obs.text} (${obs.type})`}</span>
				</div>
			))}
		</div>
	);
}

Observacoes.displayName = 'Observacoes';
Observacoes.propTypes = {
	observacoes: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.object)]),
	data: PropTypes.object,
	definicao: PropTypes.string,
	debugId: PropTypes.string
};

export default Observacoes;
